export enum ProfileOperations {
  WHO_IS_WATCHING = 'who-is-watching',
  SWITCH_ADD_PROFILE = 'switch-add-profile',
  EDIT_PROFILE = 'edit-profile',
}
